module.exports = __webpack_public_path__ + "static/media/tag-solid.978e96b4.svg";